/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {hasLightningPayments} from '../api'

export const useMutationHasLightningPayments = createReactQueryMutationHook('hasLightningPayments', hasLightningPayments)
